// extracted by mini-css-extract-plugin
export default {"dialog":"Transfers_dialog__CYTdq","warning":"Transfers_warning__1wt4L","textField":"Transfers_textField__S80Lo"};